const cartRoutes = [
  {
    path: '/direct_buy',
    name: 'direct_buy',
    component: () => import('@/views/cart/direct-buy'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/orderCreate',
    name: 'orderCreate',
    component: () => import('@/views/cart/order-create'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/selectCoupon',
    name: 'selectCoupon',
    component: () => import('@/views/cart/select-coupon'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@/views/cart/cart'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/sign-in',
    name: 'signIn',
    component: () => import('@/views/cart/sign-in'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  }
]

export default cartRoutes
